import { useState } from "react";
import NProgress from "nprogress";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import Layout from "@/components/layout/blog";
import PostPreview from "@/components/blog/post-preview";
import { getAllPostsForCategory, getAllCategoriesWithSlug } from "@/lib/api";

export default function Index({ allPosts, preview }) {
  const router = useRouter();
  const { slug } = router.query;
  const [morePosts, setMorePosts] = useState(
    allPosts?.edges[0]?.node?.posts?.nodes
  );
  const [pageInfo, setPageInfo] = useState({
    hasNextPage: allPosts?.pageInfo?.hasNextPage,
    hasPreviousPage: allPosts?.pageInfo?.hasPreviousPage,
    startCursor: allPosts?.pageInfo?.startCursor,
    endCursor: allPosts?.pageInfo?.endCursor,
  });

  const loadMore = (cursor) => async (e) => {
    NProgress.start();
    // window.scrollTo(0, 100);
    const more = await getAllPostsForCategory(false, cursor);

    setMorePosts(more.edges);
    NProgress.done(true);
    setPageInfo(more.pageInfo);
  };

  return (
    <Layout preview={preview}>
      <NextSeo
        title={`${allPosts?.edges[0]?.node?.name} Blog - IS Audtir`}
        canonical={`https://isauditr.com/blog/category/${slug}`}
        description={allPosts?.edges[0]?.node?.description}
        twitter={{
          cardType: "summary_large_image",
          site: "@isauditr",
          handle: "@isauditr",
          creator: "@isauditr",
          title: `${allPosts?.edges[0]?.node?.name} Blog - IS Audtir`,
          description: allPosts?.edges[0]?.node?.description,
        }}
        openGraph={{
          type: `article`,
          locale: `en_US`,
          siteName: "IS Auditr",
          title: `${allPosts?.edges[0]?.node?.name} Blog - IS Audtir`,
          description: allPosts?.edges[0]?.node?.description,
          url: `https://isauditr.com/blog/category/${slug}`,
          publisherName: "IS Auditr",
          publisherLogo: "https://isauditr.com/images/logo.svg",
        }}
      />

      <div
        data-elementor-type="wp-page"
        data-elementor-id="30"
        className="elementor elementor-30"
      >
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-8d8ca34 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="8d8ca34"
          data-element_type="section"
          style={{
            marginTop: 0,
          }}
        >
          <div className="elementor-container elementor-column-gap-no">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-e119795"
              data-id="e119795"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-e6bb1f7 elementor-widget elementor-widget-heading"
                  data-id="e6bb1f7"
                  data-element_type="widget"
                  data-widget_type="heading.default"
                >
                  <div className="elementor-widget-container">
                    <h1 className="elementor-heading-title elementor-size-default">
                      {allPosts?.edges[0]?.node?.name}
                    </h1>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-7a3aabb elementor-widget elementor-widget-text-editor"
                  data-id="7a3aabb"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container"></div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {morePosts.length > 0 ? (
          <section
            className="elementor-section elementor-top-section elementor-element elementor-element-be11077 elementor-section-full_width elementor-reverse-mobile elementor-section-height-default elementor-section-height-default"
            data-id="be11077"
            data-element_type="section"
            style={{
              marginTop: "4%",
            }}
          >
            <div className="elementor-container elementor-column-gap-no">
              <div className="container px-8 mx-auto xl:px-5 max-w-screen-lg">
                <div className="grid gap-10 mt-10 lg:gap-10 md:grid-cols-2 xl:grid-cols-3">
                  {allPosts?.edges[0]?.node?.posts?.nodes?.map((node) => (
                    <PostPreview
                      key={node?.slug}
                      aspect="square"
                      title={node?.title}
                      coverImage={node?.featuredImage}
                      date={node?.date}
                      author={node?.author}
                      slug={node?.slug}
                      excerpt={node?.excerpt}
                      categories={node?.categories}
                    />
                  ))}
                </div>

                <div className="flex justify-between pt-5 lg:pt-12">
                  <button
                    disabled={!pageInfo.hasPreviousPage}
                    onClick={loadMore(pageInfo.startCursor)}
                    className="py-4 px-8 rounded-full disabled:opacity-50 disabled:border-gray-100 disabled:bg-[#cccccc] bg-transparent hover:bg-primary border-2 border-primary text-primary hover:text-white capitalize font-sans font-medium text-[16px] leading-4 tracking-[-0.2px]"
                  >
                    Previous
                  </button>

                  <button
                    disabled={!pageInfo.hasNextPage}
                    onClick={loadMore(pageInfo.endCursor)}
                    className="py-4 px-8 rounded-full disabled:opacity-50 disabled:border-gray-100 disabled:bg-[#cccccc] bg-transparent hover:bg-primary focus:bg-primary border-2 border-primary focus:outline-none text-primary hover:text-white capitalize font-sans font-medium text-[16px] leading-4 tracking-[-0.2px]"
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </section>
        ) : (
          <section
            className="elementor-section elementor-top-section elementor-element elementor-element-8d8ca34 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="8d8ca34"
            data-element_type="section"
          >
            <div className="elementor-container elementor-column-gap-no">
              <div
                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-e119795"
                data-id="e119795"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div
                    className="elementor-element elementor-element-263aeb7 elementor-widget elementor-widget-heading"
                    data-id="263aeb7"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <div className="elementor-widget-container">
                      <h2
                        className="elementor-heading-title elementor-size-default"
                        style={{
                          textAlign: "center",
                        }}
                      >
                        No posts found
                      </h2>
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-7a3aabb elementor-widget elementor-widget-text-editor"
                    data-id="7a3aabb"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      Please visit in some time for the amazing content
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
      </div>
    </Layout>
  );
}

export const getStaticProps = async ({ preview = false, params }) => {
  const allPosts = await getAllPostsForCategory(params?.slug);

  return {
    props: { allPosts, preview },
    revalidate: 10,
  };
};

export const getStaticPaths = async () => {
  const allPosts = await getAllCategoriesWithSlug();

  return {
    paths:
      allPosts?.edges?.map(({ node }) => `/blog/category/${node.slug}`) || [],
    fallback: false,
  };
};
